export default "<ng-container *ngFor=\"let item of list\">\n  <span class=\"badge badge-info\">\n    {{item}}\n  </span>\n</ng-container>\n";